//
// Module for the Account Transactions Edit view
//
rs.module("content/participant/member/accounttransactions/edit",

    ["common/select-helper"],

    function (selectHelper) {

        // Initialize the module
        function initialize(jsSelectors, cssSelectors, codeValues, backendUrls, serviceCreditGrid, contributionGrid) {

            var accountTransactionDetailContainer = $.js(jsSelectors.accountTransactionDetailContainer);

            var planEmployerSelect = accountTransactionDetailContainer.js(jsSelectors.planEmployerSelect);

            var recordTypeContainer = accountTransactionDetailContainer.js(jsSelectors.recordTypeContainer, { required: false });
            var recordTypeHoverPopup = accountTransactionDetailContainer.js(jsSelectors.recordTypeHoverPopup, { required: false });

            var reportingMethodContainer = accountTransactionDetailContainer.js(jsSelectors.reportingMethodContainer, { required: false });
            var reportingMethodHoverPopup = accountTransactionDetailContainer.js(jsSelectors.reportingMethodHoverPopup, { required: false });

            var employmentTypeSelect = accountTransactionDetailContainer.js(jsSelectors.employmentTypeSelect);
            var employmentTypeSelectHelper = selectHelper.getHelper(employmentTypeSelect);

            var jobTitleSelect = accountTransactionDetailContainer.js(jsSelectors.jobTitleSelect);
            var jobTitleSelectHelper = selectHelper.getHelper(jobTitleSelect);

            var jobClassSelect = accountTransactionDetailContainer.js(jsSelectors.jobClassSelect);
            var jobClassSelectHelper = selectHelper.getHelper(jobClassSelect);

            var departmentSelect = accountTransactionDetailContainer.js(jsSelectors.departmentSelect);
            var departmentSelectHelper = selectHelper.getHelper(departmentSelect);

            var divisionSelect = accountTransactionDetailContainer.js(jsSelectors.divisionSelect);
            var divisionSelectHelper = selectHelper.getHelper(divisionSelect);

            var bargainingUnitSelect = accountTransactionDetailContainer.js(jsSelectors.bargainingUnitSelect);
            var bargainingUnitSelectHelper = selectHelper.getHelper(bargainingUnitSelect);

            var payStatusSelect = accountTransactionDetailContainer.js(jsSelectors.payStatusSelect);
            var payStatusSelectHelper = selectHelper.getHelper(payStatusSelect);

            var payGradeSelect = accountTransactionDetailContainer.js(jsSelectors.payGradeSelect);
            var payGradeSelectHelper = selectHelper.getHelper(payGradeSelect);

            var addServiceCreditLink = accountTransactionDetailContainer.js(jsSelectors.addServiceCreditLink, { required: false });
            var addSalaryGridContainer = accountTransactionDetailContainer.js(jsSelectors.addSalaryGridContainer, { required: false });
            var addContributionLink = accountTransactionDetailContainer.js(jsSelectors.addContributionLink, { required: false });

            // Register plan/employer change handler
            planEmployerSelect.change(planEmployerChanged);

            // Repopulate employment code dropdowns based on currently selected plan/employer
            function planEmployerChanged() {

                var selectedCompositeKey = planEmployerSelect.val();
                var codeKeys = Object.values(codeValues);

                // Make call to get all employment codes at once
                // Need to send array of code keys as param - not supported by $.getJSON
                $.ajax({
                    url: backendUrls.getEmploymentHistoryCodes,
                    dataType: "json",
                    data: { selectedCompositeKey: selectedCompositeKey, employmentCodeGroupKeys: codeKeys },
                    traditional: true,  // required to send array param
                    success: function (data) {
                        employmentTypeSelectHelper.clearOptions();
                        jobTitleSelectHelper.clearOptions();
                        jobClassSelectHelper.clearOptions();
                        departmentSelectHelper.clearOptions();
                        divisionSelectHelper.clearOptions();
                        bargainingUnitSelectHelper.clearOptions();
                        payStatusSelectHelper.clearOptions();
                        payGradeSelectHelper.clearOptions();

                        for (let i = 0; i < data.results.length; i++) {

                            switch (data.results[i].key) {
                                case codeValues.employmentType:
                                    employmentTypeSelectHelper.replaceOptions(data.results[i].items, { withBlank: true });
                                    break;
                                case codeValues.jobTitle:
                                    jobTitleSelectHelper.replaceOptions(data.results[i].items, { withBlank: true });
                                    break;
                                case codeValues.jobClass:
                                    jobClassSelectHelper.replaceOptions(data.results[i].items, { withBlank: true });
                                    break;
                                case codeValues.department:
                                    departmentSelectHelper.replaceOptions(data.results[i].items, { withBlank: true });
                                    break;
                                case codeValues.division:
                                    divisionSelectHelper.replaceOptions(data.results[i].items, { withBlank: true });
                                    break;
                                case codeValues.bargainingUnit:
                                    bargainingUnitSelectHelper.replaceOptions(data.results[i].items, { withBlank: true });
                                    break;
                                case codeValues.payStatus:
                                    payStatusSelectHelper.replaceOptions(data.results[i].items, { withBlank: true });
                                    break;
                                case codeValues.payGrade:
                                    payGradeSelectHelper.replaceOptions(data.results[i].items, { withBlank: true });
                                    break;
                                default:
                                    break;
                            }
                        }
                    }
                });

                // also need to re-generate salary grid, since pay items change with employer key
                $.ajax({
                    url: backendUrls.reloadSalaryGrid,
                    data: { selectedCompositeKey: selectedCompositeKey },
                    success: function (data) {
                        addSalaryGridContainer.html(data);
                    }
                });
            }

            // if record type detail popup container exists, show/hide record type detail panel on hover with intent
            if (recordTypeContainer) {
                recordTypeContainer.hoverIntent({
                    handlerOver: function (event) {
                        recordTypeHoverPopup.toggleClass(cssSelectors.visible, true);
                    },
                    handlerOut: function (event) {
                        recordTypeHoverPopup.toggleClass(cssSelectors.visible, false);
                    },
                    hoverOutDelay: 400
                });
            }

            // if reporting method detail popup container exists, show/hide reporting method detail panel on hover with intent
            if (reportingMethodContainer) {
                reportingMethodContainer.hoverIntent({
                    handlerOver: function (event) {
                        reportingMethodHoverPopup.toggleClass(cssSelectors.visible, true);
                    },
                    handlerOut: function (event) {
                        reportingMethodHoverPopup.toggleClass(cssSelectors.visible, false);
                    },
                    hoverOutDelay: 400
                });
            }

            // detail grid inline add handlers
            if (addServiceCreditLink && serviceCreditGrid) {
                addServiceCreditLink.on("click", function () {
                    serviceCreditGrid.addRow();
                });
            }

            if (addContributionLink && contributionGrid) {
                addContributionLink.on("click", function () {
                    contributionGrid.addRow();
                });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);